export const TRAINING_ONBOARDING_DATA = {
	id: 'model-training-onboarding',
	title: 'New to model training? Start with our comprehensive guide',
	imageUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/8048105c-128b-4273-b00e-91998a5e5ba6/ModelTrainingOnboardingImg.png',
	articles: [
		{
			'url': 'https://www.rundiffusion.com/train-ai-models-in-runnit-with-the-new-standard-trainer',
			'text': 'How to Train Your Model'
		},
		{
			'url': 'https://www.rundiffusion.com/how-to-prepare-a-dataset-for-model-training-on-rundiffusion',
			'text': 'How to Prepare a Dataset'
		}
	],
	onboardingData: {
		descriptionHtml: `
			<p style="font-size: 16px; color: var(--grey-400); line-height: 1.5; margin-top: 8px;">Learn how to build high-quality training datasets, select the right model type, and optimize your results with our step-by-step tutorials. Get professional-grade AI models every time.</p>
		`,
	},
};